/* Ei käytössä */

import { SocialShare } from "@quintype/components";
import get from "lodash/get";
import PT from "prop-types";
import React from "react";
import DfpAd from "../../dfp-ad";
import Breadcrumb from "../../molecules/breadcrumb";
import StickySocialShareTemplate from "../../molecules/sticky-social-share";

import SocialShareBottom from "../social-share";
import StoryCard from "../story-card";
import StoryHeader from "../story-header";
import "./photo.m.css";

class PhotoStory extends React.Component {
  render() {
    const { story } = this.props;
    const sectionId = get(story, ["sections", "0", "id"], "");
    const colombiaAdStyle = {
      minHeight: "2px",
      width: "100%"
    };
    const metakeywords = story["seo"]["meta-keywords"];
    const hashtags = metakeywords ? metakeywords.map (item => {
      return item.replace(/ /g, "");
    }) : "";

    return (
      <React.Fragment>
        {/* <ColombiaAd mobileSlotId="342678" section="ArticleShow" /> */}
        <div styleName="ad-container">
        {/* <DfpAd adtype="xxxx" slotId="belowBreakingNews" /> */}
        <p>
          <span>Mainos alkaa</span>
        </p>
        <p>
          <span>Mainos päättyy</span>
        </p>
      </div>
        {/*<Breadcrumb sectionId={sectionId} storySlug={story.slug} />*/}
        <div styleName="photo-story" className="photo-story">
          <div>
            <StoryHeader story={story} isHeroImage={false} />
            <div styleName="story-body">
              <SocialShare template={StickySocialShareTemplate} story={story} title={story.headline} url={story.slug} hashtags={story["seo"]["meta-keywords"] ? hashtags.join(",") : ""} sticky />
              <div>
                {story.cards.map((card, index) => (
                  <React.Fragment key={index}>
                    {index === 1 && (<div>At index 1</div>)}
                    {index === 2 && (
                      <div>At index 2</div>
                    )}
                    <StoryCard key={card.id} card={card} story={story} />
                  </React.Fragment>
                ))}
                <SocialShareBottom story={story} />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

PhotoStory.propTypes = {
  story: PT.object
};

export { PhotoStory };
